"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.InnovationScreenComponent = void 0;
var angular = require("angular");
var innovation_screen_chart_1 = require("./innovation-screen.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var InnovationScreenComponent = /** @class */ (function (_super) {
    __extends(InnovationScreenComponent, _super);
    function InnovationScreenComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'InnovationScreen') || this;
        _this.changeLabelLength = function (change) {
            if (change === void 0) { change = 0; }
            var ctrl = _this;
            if (!ctrl.settings.charsInLabel) {
                ctrl.settings.charsInLabel = 0;
            }
            ctrl.settings.charsInLabel = parseInt(ctrl.settings.charsInLabel);
            ctrl.settings.charsInLabel += change;
            ctrl.drawChart();
        };
        var ctrl = _this;
        $scope.$on('command:INNOVATION_SCREEN', function (event, args) { return ctrl.initComponent(event, args); });
        return _this;
    }
    InnovationScreenComponent.prototype.getChartOptions = function (graph, options) {
        return (0, innovation_screen_chart_1.getChartOptions)(graph, options);
    };
    InnovationScreenComponent.prototype.getAdditionalChartCallback = function () {
        return (0, innovation_screen_chart_1.getAdditionalChartCallback)();
    };
    InnovationScreenComponent = __decorate([
        (0, basic_chart_component_1.Component)({
            bindings: {
                menu: '='
            },
            template: require("./innovation-screen.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], InnovationScreenComponent);
    return InnovationScreenComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.InnovationScreenComponent = InnovationScreenComponent;
angular.module('smartorg.r6.acts.innovationScreen', []).component('innovationScreen', InnovationScreenComponent);
module.exports = 'smartorg.r6.acts.innovationScreen';
//# sourceMappingURL=innovation-screen.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/innovation-screen2/innovation-screen.component.js